import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RemoveWaybillItemDialogData {
  idTrade: string;
}

@Component({
  selector: 'app-remove-waybill-item-dialog',
  templateUrl: './remove-waybill-item-dialog.component.html',
  styleUrls: ['./remove-waybill-item-dialog.component.sass'],
})
export class RemoveWaybillItemDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RemoveWaybillItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemoveWaybillItemDialogData
  ) {}
}
